import {EntityMatchModel} from "../../../core/components/router/models/entity.match-model";
import {CompetitionLinkParams} from "./competition-link-params";

export class CompetitionMatchModel extends EntityMatchModel {
  params: CompetitionLinkParams;

  constructor(params: Object, path: String, url: String, hash: String) {
    super(params, path, url, hash);

    const urlParams =  url.split('/');
    const pageKey = `${this.entityName(params)}-${this.entityId(params)}`;
    const page = urlParams?.length > 4 && pageKey !== urlParams.last() ? urlParams.last() : null;

    this.params = new CompetitionLinkParams(this.entityId(params), params.sportName, this.entityName(params), page);
  }
}
